module.exports = __webpack_public_path__ + "img/baby_5.33fa02e6.jpg";